import { observer } from 'mobx-react';
import { useState } from 'react';
import { PlacementProps } from '..';
import {
  OfferingType,
  ProductLicenseResource,
  isOfferingTypeAvailableForLearningCollections,
} from '../../../../Types';
import Banner from './Banner';
import UsageOverview from './UsageOverview';

interface Props {
  productLicense: ProductLicenseResource;
  learningDesignOfferingTypes: ReadonlyArray<OfferingType>;
  placementProps?: PlacementProps;
}

function Utilization({ productLicense, learningDesignOfferingTypes, placementProps }: Props) {
  const [overviewActive, setOverviewActive] = useState<boolean>(false);

  const productLicenseOfferingTypes = productLicense.payload.offeringTypes.filter(
    isOfferingTypeAvailableForLearningCollections,
  );

  return (
    <>
      <Banner
        productLicenseOfferingTypes={productLicenseOfferingTypes}
        learningDesignOfferingTypes={learningDesignOfferingTypes}
        setOverviewActive={setOverviewActive}
        overviewActive={overviewActive}
      />
      <UsageOverview
        active={overviewActive}
        productLicense={productLicense}
        productLicenseOfferingTypes={productLicenseOfferingTypes}
        learningDesignOfferingTypes={learningDesignOfferingTypes}
        placementProps={placementProps}
      />
    </>
  );
}

export default observer(Utilization);
